import { React, useState } from 'react';
import { Card } from 'react-bootstrap';
import ReadMoreMitre from './ReadMoreMitre';
import WatchListButton from '../DocList/WatchListButton';
import RejectButton from '../DocList/RejectButton';
import RejectRemoveButton from '../DocList/RejectRemoveButton';
import WatchListRemoveButton from '../DocList/WatchListRemoveButton';
import MitreRelationship from './MitreRelationship';
import '../DocList/DocCard.scss';
import WatchlistTags from '../DocList/WatchlistTags';

const DocCardMitreAttack = ({
  doc,
  profilePrimary,
  profileSecondary,
  showAddWatchList,
  showRemove,
  list,
  allTags,
  selectedTags,
  fetchTags,
  showTags = true,
}) => {
  // if (doc.objectType === 'relationship')
  //     'id',
  //     doc.id,
  //     'source',
  //     doc.source_ref,
  //     'target',
  //     doc.target_ref
  //   );
  const docTypes = {
    'x-mitre-tactic': 'Mitre Tactic',
    'attack-pattern': 'Attack Pattern',
    'course-of-action': 'Course of Action',
    'intrusion-set': 'Intrusion Set',
    malware: 'Malware',
    tool: 'Tool',
    'x-mitre-data-source': 'Mitre Data Source',
    'x-mitre-data-component': 'Mitre Data Component',
    relationship: 'Relationship',
    identity: 'Identity',
  };
  const [tagSet, setTagSet] = useState(doc.tags);

  const updateTagSet = (action, tags) => {
    let nTagSet = [...tagSet];
    if (action === 'add') {
      nTagSet = [...nTagSet, ...tags];
    } else {
      nTagSet = nTagSet.filter((t) => tags.indexOf(t) === -1);
    }
    setTagSet(nTagSet);
  };

  return (
    <>
      {doc.objectType === 'relationship' ? (
        <MitreRelationship
          profile={profilePrimary}
          source={doc.source_ref}
          target={doc.target_ref}
        />
      ) : (
        <Card key={doc.id} className='DocCard DocCardMitreAttack'>
          <Card.Body>
            {showAddWatchList && (
              <>
                <WatchListButton
                  docId={doc.id}
                  profileId={profilePrimary.profileId}
                />
                <RejectButton
                  docId={doc.id}
                  profileId={profilePrimary.profileId}
                />
              </>
            )}
            {showRemove &&
              (list === 'rejectlist' ? (
                <RejectRemoveButton
                  docId={doc.id}
                  profileId={profilePrimary.profileId}
                />
              ) : (
                <WatchListRemoveButton
                  docId={doc.id}
                  profileId={profilePrimary.profileId}
                />
              ))}
            <div className='flex'>
              <section className='main-section'>
                {doc.title !== '(No Title)' && (
                  <Card.Title>{doc.title}</Card.Title>
                )}
                <Card.Text className='ctx-card-info'>
                  <span className='ctx-field-group'>
                    <span className='ctx-label'>Created On: </span>
                    <span className='ctx-value'>{doc.publishDate}</span>
                  </span>
                  <span className='ctx-field-group'>
                    <span className='ctx-label'>Updated On: </span>
                    <span className='ctx-value'>{doc.modified}</span>
                  </span>
                  <span className='ctx-field-group'>
                    <span className='ctx-label'>Type: </span>
                    <span className='ctx-value ctx-source'>
                      {docTypes[doc.objectType] || doc.objectType}
                    </span>
                  </span>
                  {doc.x_mitre_platforms ? (
                    <span className='ctx-field-group'>
                      <span className='ctx-label'>Platforms: </span>
                      <span className='ctx-platforms-list'>
                        {doc.x_mitre_platforms.map((platform, i) => (
                          <span key={`platform-${i}`}>{platform}</span>
                        ))}
                      </span>
                    </span>
                  ) : null}
                </Card.Text>
                {showTags ? <WatchlistTags
                  allTags={allTags}
                  docId={doc.id}
                  profileId={profilePrimary.profileId}
                  updateTagSet={updateTagSet}
                  selectedTags={selectedTags}
                  documentTags={tagSet}
                  showActions={(list === 'watchlist') && profilePrimary.roles.indexOf('curator') > -1}
                  fetchTags={fetchTags}
                /> : null}
              </section>
            </div>
            {profilePrimary &&
              profilePrimary.repositoryId &&
              doc.objectType !== 'relationship' ? (
              <ReadMoreMitre
                doc={doc}
                profilePrimary={profilePrimary}
                profileSecondary={profileSecondary}
                list={list}
                allTags={allTags}
                className='read-more-container'
                activeTags={tagSet}
                updateTagSet={updateTagSet}
              />
            ) : null}
          </Card.Body>
        </Card>
      )}
    </>
  );
};
export default DocCardMitreAttack;
